import * as httpx from "httpx"
import { CancellablePromise } from "real-cancellable-promise"

export interface DocumentPageURLResponse {
	url: string
}

export function url(pageId: string, ...options: httpx.option[]): CancellablePromise<DocumentPageURLResponse> {
	return httpx.get<DocumentPageURLResponse>(`${httpx.urlstorage.host()}/bg/document/pages/${pageId}/url`, {}, ...options)
}
